'use strict';

module.exports = {
    /**
     * 改变当前view导航样式<br />
     * 使用场景：当导航样式需要在用户交互发生改变的情况下调用<br />
     * 对应native接口：navigation.refresh
     * @method hysdk.navRefresh
     * @category Navigation
     * @example ./navRefresh.js[1-11]
     * @description
     *
     * |参数 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :--: | :--: | :--: | :--: | :--: | :--: | :--: |
     * |     | object | navigation参数，见[附录](http://ued.qunar.com/hy2/hysdk/appendix.html#导航参数) | √ | √ | X | X |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    navRefresh: {
        hy: {
            key: 'navigation.refresh'
        }
    },
    /**
     * 获取当前view导航状态，隐藏还是显示（仅仅在设置有导航栏的情况下有效）<br />
     * 使用场景：需要获取当前view的导航栏的状态<br />
     * 对应native接口：navigation.displayStatus
     * @method hysdk.getNavDisplayStatus
     * @category Navigation
     * @example ./getNavDisplayStatus.js[1-16]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    getNavDisplayStatus: {
        hy: {
            key: 'navigation.displayStatus'
        }
    },
    /**
     * 设置当前view导航状态，隐藏或者显示（仅仅在设置有导航栏的情况下有效）<br />
     * 使用场景：需要暂时隐藏导航栏或者把隐藏的导航栏显示出来的时候使用<br />
     * 对应native接口：navigation.display
     * @method hysdk.setNavDisplayStatus
     * @category Navigation
     * @example ./setNavDisplayStatus.js[1-14]
     * @description
     *
     * <table style="text-align:center">
     *     <tr>
     *         <th width="100">参数</th>
     *         <th width="80">类型</th>
     *         <th width="220">说明</th>
     *         <th width="80">iOS</th>
     *         <th width="80">Android</th>
     *         <th width="80">touch</th>
     *         <th width="80">wechat</th>
     *     </tr>
     *     <tr>
     *         <td>action</td>
     *         <td>string</td>
     *         <td>要设置的状态</td>
     *         <td rowspan="3">√</td>
     *         <td rowspan="3">√</td>
     *         <td rowspan="3">X</td>
     *         <td rowspan="3">X</td>
     *     </tr>
     *     <tr>
     *         <td>animate</td>
     *         <td>string</td>
     *         <td>使用的动画，暂时支持"none"(无动画)和"movetop"(移动动画)。可选，默认为"none"。</td>
     *     </tr>
     *     <tr>
     *         <td>time</td>
     *         <td>number</td>
     *         <td>动画持续时间，单位为秒。可选，默认为0.4</td>
     *     </tr>
     *     <tr>
     *         <td>hideStatusBar</td>
     *         <td>BOOL</td>
     *         <td>当action为"hide"时是否隐藏状态栏。<br/>为true时，状态栏也会被隐藏。可选，默认为false</td>
     *         <td>√</td>
     *         <td>X</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     * </table>
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X   |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    setNavDisplayStatus: {
        hy: {
            key: 'navigation.display'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/navigation.js
// module id = 19
// module chunks = 0 2 4